import { api } from 'shared/api'
import { FlowApiSchemas } from 'shared/api/requests/flow/schemas'

export const FlowApi = {
  getFlowContentData: api.account.createGet({
    url: '/flow/getFlowContentData',
    schemas: FlowApiSchemas.getFlowContentData,
  }),
  getFlow: api.account.createGet({
    url: '/flow/getData',
    schemas: FlowApiSchemas.getFlow,
  }),
  getFlowData: api.account.createGet({
    url: '/flow/getFlowData',
    schemas: FlowApiSchemas.getFlowData,
  }),
  setFlowName: api.account.createPost({
    url: '/flow/setName',
    schemas: FlowApiSchemas.setFlowName,
  }),
  setFlowShared: api.account.createPost({
    url: '/flow/setShared',
    schemas: FlowApiSchemas.setFlowShared,
  }),
  setFlowSharedCloning: api.account.createPost({
    url: '/flow/setSharedCloning',
    schemas: FlowApiSchemas.setFlowSharedCloning,
  }),
  importSharedFlow: api.base.createPost({
    url: '/{pageId}/flow/importSharedFlow',
    schemas: FlowApiSchemas.importSharedFlow,
  }),
}
